import { z } from "zod";
import { BladeHeaderSchema } from "../../BladeHeader";
import { BackdropSchema } from "../../Backdrop";
import { ActionSchema } from "../../Actions";
import { AnalyticsSchema, BladeCommonSchema } from "../../../types";
import { MediaSchema } from "../../Media";
const RoleSchema = z.object({
    id: z.string(),
    name: z.string(),
});
const CharacterRoleSchema = z.object({
    label: z.string(),
    roles: z.array(RoleSchema),
});
const CharaterItemSchema = z.object({
    media: MediaSchema,
    title: z.string(),
    role: CharacterRoleSchema.optional(),
    action: ActionSchema.optional(),
    analytics: AnalyticsSchema.optional(),
});
export const CharacterListBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    items: z.array(CharaterItemSchema),
});
//# sourceMappingURL=index.js.map